<script>
export default {
    name: "ImagingInvestigations",

    data() {

        return {
            imageResults: [],
            externalReporting:[],
          
            results: {},
        };
    },

    props: {

        imagingInvestigations: Array,
    },

    components: {

        "view-imaging-results": () => import('@/components/commons/medical-file/investigations/ImagingResults.vue'),
    },

    methods: {

        fetchInvestigationDetails(investigation) {
            let url = `Radiology/GetCompletedRadiologyResult`;
                url += `?PatientLabResultId=${investigation.code}`;

            return this.$http.get(url).then(response => { 
                       investigation.details = response.data; 
                   }).catch(() => {});
        },

        fetchImagingRequestsImages(inv) {
            let url = `Radiology/GetRadiologyInvestigationImageList`;
                url += `?PatientLabResultId=${inv.code}&PatientID=${inv.patientId}`

            return this.$http.get(url).then(response => {
                    this.imageResults = response.data; 
                }).catch(() => {});
        },
        fetchImagingExternalReportingImages(inv) {
      let url = `Radiology/GetRadiologyExReportingImageList`;
          url += `?PatientLabResultId=${inv.code}&PatientID=${inv.patientId}`;

      return this.$http
        .get(url)
        .then((response) => {
          this.externalReporting = response.data;
        })
        .catch(() => {});
    },

        fetchResults(inv) {
            this.$root.loading = true;
            return Promise.allSettled([ 
                    this.fetchImagingRequestsImages(inv),this.fetchImagingExternalReportingImages(inv), this.fetchInvestigationDetails(inv), 
                ]).then(() => { this.$root.loading = false; })
                .catch(() => { this.$root.loading = false; });
        },

        printMedicalFile() {
            window.print();
        },

        printRequests() {
            let url = `/medical-file/imaging-requests/print`;
                url += `/${this.$route.params.patientID}`;
                url += `/${this.$route.params.visitNo}`;

            window.open(
              url,
              "_blank",
              `ImagingRequestsPrint`,
            );
        },

        printPendingRequests() {
            let url = `/medical-file/imaging-pending-requests/print`;
                url += `/${this.$route.params.patientID}`;
                url += `/${this.$route.params.visitNo}`;

            window.open(
              url,
              "_blank",
              `ImagingRequestsPrint`,
            );
        },

        printPendingRequest(code) {
            let url = `/medical-file/imaging-pending-request/print`;
                url += `/${this.$route.params.patientID}`;
                url += `/${code}`;

            window.open(
              url,
              "_blank",
              `ImagingRequestPrint`,
            );
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap mt-1">
        <div class="w-full p-1 my-1">
            <div class="p-1 w-full bg-indigo-300 rounded-t-md">
                <h5 class="font-bold text-white text-sm">Visit #{{ $route.query.visitNo }}</h5>
            </div>
            <div class="w-full bg-gray-100 border-r-2 border-l-2 border-b-2 border-indigo-300 rounded-b p-2">
                <table class="table">
                    <thead class="bg-blue-500 text-white text-xs">
                        <tr>
                            <th class="p-tiny">Id</th>
                            <th class="p-tiny">Visit No</th>
                            <th class="p-tiny">Encounter</th>
                            <th class="p-tiny">Test</th>
                            <th class="p-tiny">Requested By</th>
                            <th class="p-tiny">Req Date</th>
                            <th class="p-tiny">Status</th>
                            <th class="p-tiny">Date Done</th>
                            <th class="p-tiny">Done By</th>
                            <th class="p-tiny hide--print">Action</th>
                        </tr>
                    </thead>
                    <tbody class="text-xs bg-gray-100">
                        <tr v-for="(inv,idx) in imagingInvestigations" :key="idx">
                            <td class="p-tiny">{{ inv.code }}</td>
                            <td class="p-tiny">{{ inv.visitNo }}</td>
                            <td class="p-tiny">{{ inv.encounterID || `-` }}</td>
                            <td class="p-tiny">{{ inv.investigation }}</td>
                            <td class="p-tiny">{{ inv.requestedBy }}</td>
                            <td class="p-tiny">{{ inv.date | dateFormat }}</td>
                            <td class="p-tiny">{{ inv.done ? `Done` : `Not Done` }}</td>
                            <td class="p-tiny">{{ inv.doneOn | dateFormat }}</td>
                            <td class="p-tiny">{{ inv.recordedBy || `-` }}</td>
                            <td class="p-tiny hide--print">
                                <button 
                                    @click.prevent="() => {
                                        fetchResults(inv).then(() => {
                                            inv.view=true;
                                        });
                                    }"
                                    class="btn-sm btn-primary rounded text-xs m-px">
                                        <i class="fa fa-eye"></i> Results</button>
                                <button 
                                    @click.prevent="printPendingRequest(inv.code)"
                                    class="btn-sm btn-info rounded text-xs m-px">
                                        <i class="fa fa-print"></i> Print Req</button>
                                <router-link
                                      v-if="
                                            ($root.formatLowercase(inv.userName) ==
                                            $root.formatLowercase($root.username)) ||
                                            $root.checkAuth('AdminEditMedicalFile')
                                          " 
                                      :to="{
                                        name: `med-f.visit.index`,
                                        params: {
                                          patientID: $route.params.patientID,
                                          visitNo: $route.params.visitNo,
                                        },
                                        query: {
                                          encounterID: inv.encounterID,
                                          from: $route.query.from,
                                        },
                                      }" 
                                      class="btn-sm btn-warning text-xs text-white rounded hide--print m-px">
                                    <i class="fa fa-times"></i> Cancel
                                </router-link>
                                <view-imaging-results 
                                    :investigation="inv"
                                    :results="results"
                                    :imageResults="imageResults"
                                    :externalReportingResults="externalReporting"
                                    :routeParams="{
                                        patientID: $route.params.patientID,
                                    }"
                                    :showModal="inv.view"
                                    @closeModal="inv.view=false"
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="w-full p-1 text-right">
            <button 
                @click.prevent="printRequests"
                class="btn-sm btn-primary text-xs hide--print mr-4">
                    <i class="fa fa-print"></i> Print</button>
            <button 
                @click.prevent="printPendingRequests"
                class="btn-sm btn-info text-xs hide--print">
                    <i class="fa fa-print"></i> Pending Requests</button>
        </div>
    </div>
</template>
<style scoped>
@media print {
    .hide--print {
        display: none;
    }
}
</style>
